import React from "react";
import cn from "classnames";
import Header from "./components/header";
import Main from "./components/main";
import styles from "./styles.css";
import { script } from "./script";
import { menu, userMenu, makeId } from "./config";

class Prototype extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    if (typeof document !== "undefined") {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.innerHTML = script;
      document.body.appendChild(s);
    }
  }

  submenu = ({ id, items, name }) => {
    if (name === "Destinations") {
      return this.destinationsMenu({
        id,
        destinations: items,
      });
    }

    return (
      <ul className={styles["prototype-tier-2"]} data-component="tier-2-menu" id={id} hidden>
        {items.map((item) => (
          <li key={item.name}>
            <a href={item.url}>{item.name}</a>
          </li>
        ))}
      </ul>
    );
  };

  destinationsMenu = ({ id, destinations }) => (
    <ul className={styles["prototype-tier-2"]} data-component="tier-2-menu" id={id} hidden>
      {destinations.map((destination) => {
        const hasTier3 = destination.countries && destination.countries.length > 0;
        const tier3Id = makeId(destination.url);

        return (
          <li
            key={destination.name}
            className={styles["prototype-item"]}
            data-component={hasTier3 ? "tier-3-menu-button" : null}
          >
            <a
              href={destination.url}
              data-menu={hasTier3 ? tier3Id : null}
            >
              {destination.name}
            </a>

            {hasTier3 && this.countryMenu({
              id: tier3Id,
              countries: destination.countries,
            })}
          </li>
        );
      })}
    </ul>
  );

  countryMenu = ({ id, countries }) => (
    <ul className={styles["prototype-tier-3"]} data-component="tier-3-menu" id={id} hidden>
      {countries.map((country) => {
        const hasTier4 = country.cities && country.cities.length > 0;
        const tier4Id = makeId(country.url);

        return (
          <li
            key={country.name}
            className={styles["prototype-item"]}
            data-component={hasTier4 ? "tier-4-menu-button" : null}
          >
            <a
              className={styles["prototype-country"]}
              href={country.url}
              data-menu={hasTier4 ? tier4Id : null}
            >
              {country.flag ?
                <img className={styles["prototype-flag"]} src={country.flag} alt="" /> :
                <div className={styles["prototype-flag"]}></div>
              }{country.name}
            </a>

            {hasTier4 && this.citiesMenu({
              id: tier4Id,
              cities: country.cities,
            })}
          </li>
        );
      })}
    </ul>
  );

  citiesMenu = ({ id, cities }) => (
    <ol
      className={styles["prototype-tier-4"]}
      data-component="tier-4-menu"
      id={id}
      hidden
    >
      {cities.map((city, index) => (
        <li key={city.url}>
          <a className={styles["prototype-city"]} href={city.url}>
            <span className={styles["prototype-number"]} aria-hidden="true">{index + 1}</span>{city.name}
          </a>
        </li>
      ))}
    </ol>
  )

  render() {
    return (
      <React.Fragment>
        <Header styles={styles} />

        <nav className={styles["prototype-nav"]}>
          <ul className={styles["prototype-tier-1"]} data-component="tier-1-menu">
            {menu.map((item) => {
              const hasTier2 = item.submenu && item.submenu.length > 0;
              const tier2Id = makeId(item.url);

              return (
                <li
                  key={item.name}
                  className={styles["prototype-item"]}
                  data-component={hasTier2 ? "tier-2-menu-button": null}
                >
                  <a
                    href={item.url}
                    data-menu={hasTier2 ? tier2Id : null}
                  >
                    {item.name}
                  </a>

                  {hasTier2 && this.submenu({
                    id: tier2Id,
                    items: item.submenu,
                    name: item.name,
                  })}
                </li>
              );
            })}

            {userMenu.map((userItem, index) => (
              <li
                key={userItem.name}
                className={cn(index === 0 && styles["prototype-user-menu-item"])}
              >
                <a href={userItem.url}>
                  {userItem.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <Main styles={styles} />
      </React.Fragment>
    );
  }
}

export default Prototype;
